import { createSelector } from 'reselect';
import lodash from 'lodash';

const inboxDocumentInstitutionIdSelector = state =>
    lodash.get(state, 'form.inboxItem.document.institutionId');

const sentDocumentInstitutionIdSelector = state =>
    lodash.get(state, 'form.sentItem.document.institutionId');

const sdfaDocumentInstitutionIdSelector = state =>
    lodash.get(state, 'routing.locationBeforeTransitions.query.iid');

export const taskDocumentInstitutionIdSelector = createSelector(
    inboxDocumentInstitutionIdSelector,
    sentDocumentInstitutionIdSelector,
    sdfaDocumentInstitutionIdSelector,
    (inboxDocIid, sentDocIid, sdfaDocIid) => lodash([inboxDocIid, sentDocIid, sdfaDocIid])
        .compact().head()
);

export const meInstitutionFeaturesSelector = (state, institutionId) =>
    lodash.get(state, `me.featureAccess.${institutionId}`, {});

export const meMonitorInstitutionFeaturesSelector = (state, institutionId) =>
    lodash.get(state, `me.monitorFeatureAccess.${institutionId}`, {});

export const binderPropertySelector = (state, binderProperty) => {
    return lodash.get(state, `binder.${binderProperty}`);
};

export const monitorInstitutionIdsSelector = state =>
    lodash.map(
        lodash.get(state, 'me.monitorInstitutions'),
        monitorInstitution => { return monitorInstitution.id; }
    );

export const internalInstitutionIdsSelector = state =>
    lodash.map(
        lodash.get(state, 'me.institutions'),
        internalInstitution => { return internalInstitution.id; }
    );

export const homeRouteSelector = (state) => {
    return '/binders';
};

export const binderRouteSelector = (state) => {
    let data = '/binders';
    return data;
};

export const defaultStudyFallbackRouteSelector = (state) => {
    const studyId = lodash.get(state, 'study.id');
    return `/study/${studyId}/documents`;
};
